module.exports = __webpack_public_path__ + "img/face_highrisk.6982bd22.png";